import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Header from "./components/Header";
import "./App.css";
import HelpUs from "./pages/HelpUs";
import Catalogo from "./pages/Catalogo";
import Footer from "./components/Footer";
import AboutUs from "./pages/AboutUs";
import Adoptions from "./pages/Adoptions";
import Contact from "./pages/Contact";
import ProductPage from "./pages/ProductPage";
import AdminLogin from "./backoffice/AdminLogin";
import Dashboard from "./backoffice/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import Activities from "./pages/Activities";


function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/catalogo" element={<Catalogo />} />
        <Route path="/sobre" element={<AboutUs />} />
        <Route path="/ayuda" element={<HelpUs />}/>
        <Route path="/adopcion" element={<Adoptions />}/>
        <Route path="/contacto" element={<Contact />}/>
        <Route path="/product/:productId" element={<ProductPage />}/>
        <Route path="/admin" element={<AdminLogin />}/>
        <Route path="/product/:productId" element={<ProductPage />}/>
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>
        <Route path="/actividades" element={<Activities/>}/>

      </Routes>
      <Footer />
    </Router>
  );
}

export default App;

